import {
  FormGroupState,
  createFormGroupState,
  updateGroup,
  validate,
  formGroupReducer,
} from 'ngrx-forms';
import { required } from 'ngrx-forms/validation';
import { Action } from '@ngrx/store';

// tslint:disable:interface-name
export interface AuthLoginForm {
  email: string | null;
  password: string | null;
  remember: boolean;
}

// tslint:disable:interface-name
export interface AuthLoginState {
  form: FormGroupState<AuthLoginForm>;
  successful: boolean | null;
  error: boolean | null | string;
}

export const AUTH_LOGIN_FORM_ID = 'login-form';

export const AUTH_LOGIN_FORM_INITIAL_STATE: AuthLoginForm = {
  email: null,
  password: null,
  remember: true,
};

export const authLoginInitialState: AuthLoginState = {
  form: createFormGroupState(AUTH_LOGIN_FORM_ID, AUTH_LOGIN_FORM_INITIAL_STATE),
  successful: null,
  error: null,
};

export const authLoginValidateAndUpdateForm = updateGroup<AuthLoginForm>({
  email: validate(required),
  password: validate(required),
});

export function authLoginReducer(
  state = authLoginInitialState,
  action: Action,
): AuthLoginState {
  const form = formGroupReducer(state.form, action);
  if (form !== state.form) {
    state = { ...state, form: authLoginValidateAndUpdateForm(form) };
  }

  return state;
}
